export enum DocumentTypes {
  Form = 'Form',
  File = 'File',
}

export interface DocumentVaultResponseType {
  DocumentBuffer: any;
  Filename: string;
}
